// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".email-container span:first-child{padding-top:.25rem}.email-container a{word-break:break-word}", "",{"version":3,"sources":["webpack://src/components/member/email-info.scss"],"names":[],"mappings":"AACE,kCACE,kBAAA,CAGF,mBACE,qBAAA","sourcesContent":[".email-container {\n  span:first-child {\n    padding-top: 0.25rem;\n  }\n\n  a {\n    word-break: break-word;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
